// extracted by mini-css-extract-plugin
module.exports = {"globalFooter":"index_globalFooter-23LWp","links":"index_links-1IOVF","copyright":"index_copyright-2c8dn"};